import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { passwordRequest, passwordResetRequest } from '../actions';
import Expired from '../components/pages/Expired';
import ChangePassword from '../components/pages/ChangePassword';
import ResetPassword from '../components/pages/ResetPassword';

class LoginContainer extends Component {
  render() {
    const {
      passwordRequest,
      passwordResetRequest,
      error,
      currentlySending,
      loading,
      location,
      match,
    } = this.props;

    if (location.pathname === '/ui/login/expired') {
      return (
        <Expired
          passwordRequest={passwordRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else if (location.pathname === '/ui/login/change-password') {
      return (
        <ChangePassword
          passwordRequest={passwordRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else if (/\/ui\/login\/reset-password/i.test(location.pathname)) {
      return (
        <ResetPassword
          username={match.params.username}
          passwordResetRequest={passwordResetRequest}
          error={error}
          currentlySending={currentlySending}
          loading={loading}
        />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    error: state.requests.error,
    currentlySending: state.requests.currentlySending,
    loading: state.requests.loading,
    helperText: state.loginHelpText,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      passwordRequest: passwordRequest,
      passwordResetRequest: passwordResetRequest,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
